import cn from 'classnames';

import {
  TextLineHeight,
  type TextPropsInterface,
  TextSize,
  TextWeight,
} from '@app/components/Text/types';

import type { FC } from 'react';

import '@app/components/Text/styles/Text.desktop.scss';

export const Text: FC<TextPropsInterface> = ({
  children,
  display,
  className,
  style,
  textShadow,
  height,
  width,
  textDecoration,
  transition = 'color 0.2s ease-out',
  cursor = 'default',
  pattern = 'body1',
  color = '#373A3C',
  textAlign = 'left',
  whiteSpace = 'unset',
  overflowY = 'unset',
  overflowX = 'unset',
  textOverflow = 'unset',
  userSelect = 'auto',
  fontSize = 0,
  weight = 0,
  lineHeight = 0,
  margin = 0,
  padding = 0,
  ...props
}) => (
  <div
    className={cn('ui-text-container', className)}
    style={{
      display,
      transition,
      cursor,
      textAlign,
      color,
      margin,
      padding,
      whiteSpace,
      overflowY,
      overflowX,
      textOverflow,
      textShadow,
      userSelect,
      height,
      width,
      textDecoration,
      fontSize: `${fontSize || TextSize[pattern]}px`,
      fontWeight: weight || TextWeight[pattern],
      lineHeight: `${lineHeight || TextLineHeight[pattern]}px`,
      ...style,
    }}
    {...props}
  >
    {children}
  </div>
);
